import { FaArrowDown, FaArrowUp } from 'react-icons/fa'
import { useEffect, useRef, useState } from 'react'
import { MultiSelectContainer } from './styles'

export type CheckboxMultiSelectOption = {
  value: string | number
  label: string
}

type CheckboxMultiSelectProps = {
  label: string
  fieldId: string
  options: CheckboxMultiSelectOption[]
  selectedValues: Array<string | number>
  onChange: (values: Array<string | number>) => void
  placeholder?: string
}

export const CheckboxMultiSelect = ({
  label,
  fieldId,
  options,
  selectedValues,
  onChange,
  placeholder = 'Todos'
}: CheckboxMultiSelectProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  const [displayText, setDisplayText] = useState(placeholder)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  useEffect(() => {
    if (!selectedValues.length) {
      setDisplayText(placeholder)
      return
    }
    const labels = selectedValues
      .map(value => options.find(option => option.value === value)?.label)
      .filter(Boolean) as string[]
    setDisplayText(labels.join(', '))
  }, [options, placeholder, selectedValues])

  const toggleValue = (value: string | number, checked: boolean) => {
    if (checked) {
      onChange([...selectedValues, value])
      return
    }
    onChange(selectedValues.filter(selected => selected !== value))
  }

  return (
    <MultiSelectContainer className="mb-6" ref={ref}>
      <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
        {label}
      </label>
      <div
        style={{ position: 'relative' }}
        onClick={() => setOpen(prev => !prev)}
      >
        <textarea
          rows={2}
          readOnly
          className="form-control form-control-solid pl-2"
          value={displayText}
        />
        <div className="arraw-container">
          <div style={{ display: open ? 'none' : 'block' }}>
            <FaArrowDown />
          </div>
          <div style={{ display: !open ? 'none' : 'block' }}>
            <FaArrowUp />
          </div>
        </div>
      </div>
      <div className="items-container">
        <div
          style={{ display: open ? 'block' : 'none' }}
          className="items-container-inner"
        >
          {options.map(option => {
            const inputId = `${fieldId}_${option.value}`
            return (
              <div className="list-item" key={inputId}>
                <input
                  type="checkbox"
                  name={inputId}
                  id={inputId}
                  value={option.value}
                  checked={selectedValues.includes(option.value)}
                  onChange={e => toggleValue(option.value, e.target.checked)}
                  onClick={e => e.stopPropagation()}
                />
                <label htmlFor={inputId} className="mx-2">
                  {option.label}
                </label>
              </div>
            )
          })}
        </div>
      </div>
    </MultiSelectContainer>
  )
}
